import { ChoiseDocVersionModalComponent } from './../choise-doc-version-modal/choise-doc-version-modal.component'
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core'
import * as Enum from '../utils/enums'
import { AlertUtil } from '../utils/alert-util'
import { IDocumento } from '../interfaces/IDocumento'
import { DocumentiService } from '../services/documenti.service'
import { RequestBuilder } from '../classes/request-builder'
import { Loading } from '../utils/loading'
import { finalize } from 'rxjs/operators'
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte'
import { DialogService } from 'primeng/api'
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component'
import * as Constants from '../utils/constants'
import { StoricoModuloService } from '../services/storicomodulo.service'
import { DocumentoPrefettoModalComponent } from '../documento-prefetto-modal/documento-prefetto-modal.component'
import { Util } from '../utils/util'
import { CommessaService } from '../services/commessa.service'
import { ICommessa } from '../interfaces/ICommessa'
import { ICantiere } from '../interfaces/ICantiere'
import { IRichiesta } from '../interfaces/IRichiesta'
import { IEsecutore } from '../interfaces/IEsecutore'
import { AziendaService } from '../services/azienda.service'
import { DataTableComponent } from '../data-table/data-table.component'
import { IVersione } from '../interfaces/IVersione'

@Component({
  selector: 'app-full-text-serch',
  templateUrl: './full-text-serch.component.html',
  styleUrls: ['./full-text-serch.component.css']
})
export class FullTextSerchComponent implements OnInit {
  @ViewChild("dt") dataTable: DataTableComponent //viewchild for enabled button search
  searchResults: IDocumento[]     // table data source
  rowSelected: boolean = false    //determines whether one commessa row has been clicked
  documentoSelected: IDocumento   // documento selected from table

  //Dropdown COMMESSE
  commesseList: ICommessa[] = []      //list commesse
  commessaSelected: ICommessa = null  //commessa selected

  //Dropdown CANTIERI
  cantieriList: ICantiere[] = []      //list cantieri
  cantiereSelected: ICantiere = null  //cantiere selected

  //Dropdown RICHIESTA
  richiesteList: IRichiesta[] = []      //list richiesta
  richiestaSelected: IRichiesta = null  //richiesta selected

  //Dropdown AZIENDA
  aziendeList: IEsecutore[] = []           // list aziende
  aziendaSelected: any = null                //azienda selected

  // loading entities
  isCommesseLoading: boolean = false
  isCantieriLoading: boolean = false
  isRichiesteLoading: boolean = false
  isAziendeLoading: boolean = false

  //check user role
  isAdmin: boolean
  isAffidatario: boolean
  isAggiudicatario: boolean
  isEsecutore: boolean
  isPrefetto: boolean

  @Output() dataLoaded: EventEmitter<any> = new EventEmitter<any>()

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  constructor(private alertUtil: AlertUtil, private documentiService: DocumentiService,
    private dialogService: DialogService, private storicoModuloService: StoricoModuloService,
    private commessaService: CommessaService,
    private aziendaService: AziendaService) {

    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.isPrefetto = false
    this.isEsecutore = false
    this.checkUserRole(userRole)
  }

  ngOnInit() {
    // setInterval(() => {
    //   console.log("Loading = " + Loading.isLoading)
    // }, 200)

    setTimeout(() => {
      this.setDropDownDefault()
    }, 0)
  }

  /**
   * check role of user logged
   */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO
      || userRole == Enum.USER_TYPE_ENUM.GVS
      || userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isAffidatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true
    } else if (userRole == Enum.USER_TYPE_ENUM.PREFETTURA
      || userRole == Enum.USER_TYPE_ENUM.DL) {
      this.isPrefetto = true
    }
  }

  /**
   * set dropdown value
   */
  setDropDownDefault() {
    this.getAllCommesse()
  }

  /**
  * drop down commesse event
  * @param commessa 
  */
  onChangeCommessa(event: any) {
    this.commessaSelected = event.value
    this.checkDropdownValid()
    if (this.commessaSelected) {
      this.getAllCantieri()
      this.getAllRichiesta()
      this.getAllAziende()
    } else {
      this.searchResults = []
      this.setDropDownDefault()
    }
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    this.isCommesseLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllInterventi(reqBuilder).pipe(
      finalize(() => {
        this.isCommesseLoading = false
      })
    ).subscribe(
      response => {
        if (response.data) {
          this.commesseList = response.data
          this.getAllCantieri()
          this.getAllRichiesta()
          this.getAllAziende()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
    * retrieve all cantieri by commesse[]
  */
  getAllCantieri() {
    this.isCantieriLoading = true
    let reqBuilder = new RequestBuilder({
      Commesse: this.commessaSelected ? [this.commessaSelected] : this.commesseList
    })
    this.commessaService.getAllCantieriCommesse(reqBuilder).pipe(finalize(() => {
      this.isCantieriLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.cantieriList = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
  * retrieve all richieste by commesse []
  */
  getAllRichiesta() {
    this.isRichiesteLoading = true
    let reqBuilder = new RequestBuilder({
      Commesse: this.commessaSelected ? [this.commessaSelected] : this.commesseList
    })
    this.commessaService.getAllRichiesteCommesse(reqBuilder).pipe(finalize(() => {
      this.isRichiesteLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.setRichiestaForSearch(response.data)
          this.richiesteList = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * add RichRif for combo of search
   */
  private setRichiestaForSearch(response: IRichiesta[]) {
    response.forEach(richiesta => {
      richiesta["RichRif"] = richiesta.Riferimento + " / " + richiesta.TipoContratto.TipoRichiesta.Nome
    })
  }

  /**
    * retrieve all aziende
  */
  getAllAziende() {
    this.isAziendeLoading = true
    //Modifica per filtrare le aziende in base alla commessa selezionata, se non c'è mostriamo tutte le aziende
    let reqBuilder = new RequestBuilder({
      Commesse: this.commessaSelected ? [this.commessaSelected] : this.commesseList
    })

    this.aziendaService.getAllEsecutori(reqBuilder).pipe(
      finalize(() => {
        this.isAziendeLoading = false
      })
    ).subscribe(
      response => {
        if (response.data) {
          this.aziendeList = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
  * drop down aggiudicatario event
  * @param aggiudicatario 
  */
  onChangeAzienda(event: any) {
    this.aziendaSelected = event.value
    if (!this.aziendaSelected) {
      if (this.checkDropDownValue()) {
        this.clickSearch(null)
      } else {
        this.searchResults = null
      }
    }
    this.checkDropdownValid()
  }


  /**
  * drop down richiesta event
  * @param richiesta 
  */
  onChangeRichiesta(event: any) {
    this.richiestaSelected = event.value
    if (!this.richiestaSelected) {
      this.aziendaSelected = null
      if (this.checkDropDownValue()) {
        this.clickSearch(null)
      } else {
        this.searchResults = null
      }
    }
    this.checkDropdownValid()
  }


  /**
  * drop down cantiere event
  * @param cantiere 
  */
  onChangeCantiere(event: any) {
    this.cantiereSelected = event.value
    if (!this.cantiereSelected) {
      this.aziendaSelected = null
      if (this.checkDropDownValue()) {
        this.clickSearch(null)
      } else {
        this.searchResults = null
      }
    }
    this.checkDropdownValid()
  }



  /**
   * row selected
   * @param documento obj selected
   */
  onRowSelected(documento: IDocumento) {
    this.rowSelected = true
    this.documentoSelected = documento
    if (this.isPrefetto) {
      this.callGetVerionsService(this.documentoSelected)
    } else {
      this.callStoricoModuloFetchSingle(0)
    }
  }

  /**
   * row unselected
   */
  onRowUnselected() {
    this.rowSelected = false
  }

  /**
   * button full text search clicked
   * @param textSearched text
   */
  clickSearch(textSearched: string) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({
      IdCommessa: (this.commessaSelected) ? this.commessaSelected.Id : '%',
      IdCantiere: (this.cantiereSelected) ? this.cantiereSelected.Id : '%',
      IdRichiesta: (this.richiestaSelected) ? this.richiestaSelected.Id : '%',
      idAzienda: (this.aziendaSelected) ? this.aziendaSelected.Id : '%',
      Text: !textSearched ? "" : textSearched
    })
    this.documentiService.fullTextSearch(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.searchResults = response.data
          // reset datatable
          this.dataTable.resetTable()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          if (response.error.Code == 305) {
            this.searchResults = null
          }
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * Click on button to show PDF
   * @param documento 
   */
  onClickShowPDF(documento: IDocumento) {
    this.callGetVerionsService(documento)
  }

  /**
   * call visualizza Pdf service
   * @param documento 
   */
  private callVisualizzaPdf(documento: IDocumento) {
    Loading.isLoading = true
    let documentoCloned: IDocumento = {
      Id: documento.Id,
      Nome: documento.Nome,
      Descrizione: documento.Descrizione,
      Tipologia: documento.Tipologia,
      Data_scadenza: documento.Data_scadenza,
      Documento: documento.Documento,
      DocumentoCreato: documento.DocumentoCreato,
      Autore: documento.Autore,
      Versione: -1
    }
    let reqBuilder = new RequestBuilder(documentoCloned)
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response && response["error"] == null) {
        Util.showPdf(response)
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + JSON.stringify(response.error.Stack))
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0"
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }

  /**
   * get all versions for document
   */
  callGetVerionsService(documento: IDocumento) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({
      Id: documento.Id
    })
    this.storicoModuloService.getAllVersions(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          let arrayVersion: IVersione[] = response.data
          if (arrayVersion && arrayVersion.length > 1) {
            documento.Versioni = arrayVersion
            this.openChooseVersionModal(documento)
          } else {
            if (this.isPrefetto) {
              this.callStoricoModuloFetchSingle(0)
            } else {
              this.callVisualizzaPdf(documento)
            }
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * open choose version documento modal
   * @param documento 
   */
  openChooseVersionModal(documento: IDocumento) {
    let chooseDocumentoModal = this.dialogService.open(ChoiseDocVersionModalComponent, {
      data: { documento, isPrefetto: this.isPrefetto },
      header: documento.Nome,
      width: '50%'
    })
    chooseDocumentoModal.onClose.subscribe((versionSelected) => {
      if (versionSelected) { //force refresh 
        this.callStoricoModuloFetchSingle(versionSelected.Versione)
      }
    })
  }

  /**
   * read documento Selected and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
   * open documento modal
   * @param documento 
   */
  openDocumentoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoModalComponent, {
      data: { documento, richiesta: documento.Richiesta, fromFullTextSearch: true },
      header: documento.Nome,
      width: '80%'
    })
    documentoModal.onClose.subscribe((documentoObj) => {
      if (documentoObj) { //force refresh 
        this.rowSelected = false
        this.callStoricoModuloFetchSingle(0)
      }
    })
  }

  /**
   * call storicoModulo fetch single
   */
  callStoricoModuloFetchSingle(versioneDoc: number) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.documentoSelected.Id,
      Version: versioneDoc > 0 ? versioneDoc : null
    })
    this.storicoModuloService.storicoModuloFetchSingle(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.documentoSelected = response.data
          this.createCustomResponse()
          if (this.rowSelected) {
            this.checkUserRoleAndOpenModal(versioneDoc > 0 ? versioneDoc : -1)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * check user role and open modal
   */
  private checkUserRoleAndOpenModal(versioneDoc: number) {
    //if prefetto open specific modal
    if (this.isPrefetto) {
      this.documentoSelected.Versione = versioneDoc
      this.openPrefettoModal(this.documentoSelected)
    }
    else {
      this.openDocumentoModal(this.documentoSelected)
    }
  }

  /**
   * open prefetto modal
   * @param documento 
   */
  openPrefettoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoPrefettoModalComponent, {
      data: { documento, richiesta: documento.Richiesta },
      header: documento.Nome,
      width: '35%'
    })
    documentoModal.onClose.subscribe((documentoObj) => {
      if (documentoObj) { //force refresh 
        this.rowSelected = false
      }
    })
  }

  /**
   * check dropdown valid
   */
  checkDropdownValid() {
    let inputValid: boolean =
      this.commessaSelected != null ||
      this.cantiereSelected != null ||
      this.aziendaSelected != null ||
      this.richiestaSelected != null
    this.dataTable.changeFullTextInputBooleanValue(inputValid)
  }

  /**
   * check dropdown value
   */
  checkDropDownValue(): boolean {
    return this.commessaSelected != null ||
      this.cantiereSelected != null ||
      this.aziendaSelected != null ||
      this.richiestaSelected != null
  }
}
